import { CodeBlock } from '@atlaskit/code';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { codeMigrateToTokensJS, codeMigrateToTokensCSS, codeTokensCodemmod, codeCodemodCli } from "../../../../src/snippets/code/migrate-to-tokens";
import * as React from 'react';
export default {
  CodeBlock,
  SectionMessage,
  SectionMessageAction,
  codeMigrateToTokensJS,
  codeMigrateToTokensCSS,
  codeTokensCodemmod,
  codeCodemodCli,
  React
};